// FloatingShapes.js
import React from 'react';
import { motion } from 'framer-motion';
import { Cloud, Shield, Bot, Cpu, Code2, Database, Server } from 'lucide-react';

const floatingEmojis = [
  { emoji: '💻', from: { x: '5vw', y: '10vh' }, to: { x: '10vw', y: '5vh' }, delay: 0 },
  { emoji: '☁️', from: { x: '90vw', y: '25vh' }, to: { x: '85vw', y: '20vh' }, delay: 0.4 },
  { emoji: '⚙️', from: { x: '10vw', y: '75vh' }, to: { x: '15vw', y: '70vh' }, delay: 1.2 },
  { emoji: '🤖', from: { x: '45vw', y: '65vh' }, to: { x: '55vw', y: '60vh' }, delay: 1.6 },
  { emoji: '🧠', from: { x: '20vw', y: '40vh' }, to: { x: '25vw', y: '35vh' }, delay: 2.0 },
];

const lucideIcons = [
  { Icon: Cpu, from: { x: '25vw', y: '20vh' }, to: { x: '30vw', y: '15vh' }, delay: 0.6 },
  { Icon: Shield, from: { x: '70vw', y: '80vh' }, to: { x: '75vw', y: '75vh' }, delay: 1.0 },
  { Icon: Bot, from: { x: '40vw', y: '30vh' }, to: { x: '45vw', y: '25vh' }, delay: 1.4 },
  { Icon: Code2, from: { x: '60vw', y: '60vh' }, to: { x: '65vw', y: '55vh' }, delay: 2.2 },
  { Icon: Database, from: { x: '80vw', y: '10vh' }, to: { x: '75vw', y: '15vh' }, delay: 2.6 },
  { Icon: Server, from: { x: '10vw', y: '50vh' }, to: { x: '15vw', y: '45vh' }, delay: 2.8 },
];

const geometricShapes = [
  { shape: '●', from: { x: '35vw', y: '85vh' }, to: { x: '37vw', y: '80vh' }, delay: 1.8 },
  { shape: '▲', from: { x: '50vw', y: '10vh' }, to: { x: '52vw', y: '5vh' }, delay: 2.4 },
  { shape: '◆', from: { x: '15vw', y: '60vh' }, to: { x: '20vw', y: '55vh' }, delay: 2.7 },
];

const FloatingShapes = () => {
  return (
    <>
      {/* Emoji Icons */}
      {floatingEmojis.map((item, i) => (
        <motion.div
          key={`emoji-${i}`}
          className="absolute text-2xl sm:text-3xl opacity-30 z-0 pointer-events-none"
          style={{ left: item.from.x, top: item.from.y }}
          animate={{
            left: item.to.x,
            top: item.to.y,
            opacity: [0.2, 0.5, 0.2],
            scale: [1, 1.1, 1],
            rotate: [0, 10, -10, 0],
          }}
          transition={{
            duration: 7,
            delay: item.delay,
            repeat: Infinity,
            repeatType: 'reverse',
            ease: 'easeInOut',
          }}
        >
          {item.emoji}
        </motion.div>
      ))}

      {/* Lucide Tech Icons */}
      {lucideIcons.map(({ Icon, from, to, delay }, i) => (
        <motion.div
          key={`icon-${i}`}
          className="absolute text-white opacity-20 z-0 pointer-events-none"
          style={{ left: from.x, top: from.y }}
          animate={{
            left: to.x,
            top: to.y,
            opacity: [0.2, 0.6, 0.2],
            rotate: [0, 15, -15, 0],
            scale: [1, 1.05, 1],
          }}
          transition={{
            repeat: Infinity,
            repeatType: 'reverse',
            duration: 7,
            delay,
            ease: 'easeInOut',
          }}
        >
          <Icon className="w-5 h-5 sm:w-6 sm:h-6" />
        </motion.div>
      ))}

      {/* Geometric Patterns */}
      {geometricShapes.map(({ shape, from, to, delay }, i) => (
        <motion.div
          key={`geo-${i}`}
          className="absolute text-white/20 text-xl sm:text-2xl font-bold z-0 pointer-events-none"
          style={{ left: from.x, top: from.y }}
          animate={{
            left: to.x,
            top: to.y,
            scale: [1, 1.1, 1],
            opacity: [0.1, 0.4, 0.1],
          }}
          transition={{
            duration: 6,
            delay,
            repeat: Infinity,
            repeatType: 'reverse',
            ease: 'easeInOut',
          }}
        >
          {shape}
        </motion.div>
      ))}
    </>
  );
};

export default FloatingShapes;
